import defaultAnswer from "./defaultanswer";
export default function selectDropdownOptions(selected){

    // Hide all options
    $(".desc").hide();

    // Show options from selected dropdown
    $('#' + selected).show('slow');

    $('#dropdown-options option').each(function(){
        $(this).removeAttr('selected');
    });

    $('[data-id='+selected+']').attr('selected', 'selected');

    $('.selectpicker').selectpicker('refresh');

    defaultAnswer(selected);

}